export default "__VITE_ASSET__v2p5LHIp__"